import { CheckCircle, AlertTriangle } from 'lucide-react';
import Card from '@/components/ui/Card';
import type { Address } from './types';

interface FraudRiskCardProps {
  ipAddress?: string | null;
  userAgent?: string | null;
  shippingAddress?: Address;
  billingAddress?: Address;
}

export default function FraudRiskCard({ ipAddress, userAgent, shippingAddress, billingAddress }: FraudRiskCardProps) {
  if (!ipAddress && !userAgent) {
    return null;
  }

  const addressMismatch =
    shippingAddress && billingAddress
      ? shippingAddress.city !== billingAddress.city ||
        shippingAddress.state !== billingAddress.state ||
        shippingAddress.postal_code !== billingAddress.postal_code
      : false;

  return (
    <Card title="Fraud & Risk" padding="md">
      <div className="space-y-3 text-sm">
        {ipAddress && (
          <div>
            <span className="text-stone-500">IP Address:</span>{' '}
            <span className="text-stone-700 font-mono">{ipAddress}</span>
          </div>
        )}

        {userAgent && (
          <div>
            <span className="text-stone-500">User Agent:</span>{' '}
            <span className="text-stone-500 text-xs break-all">{userAgent}</span>
          </div>
        )}

        {shippingAddress && billingAddress && (
          <div className="flex items-center gap-2 pt-2 border-t border-stone-100">
            {addressMismatch ? (
              <>
                <AlertTriangle className="h-4 w-4 text-amber-500" />
                <span className="text-amber-700">Shipping and billing addresses differ</span>
              </>
            ) : (
              <>
                <CheckCircle className="h-4 w-4 text-green-500" />
                <span className="text-green-700">Shipping and billing addresses match</span>
              </>
            )}
          </div>
        )}
      </div>
    </Card>
  );
}
